var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgCardLinkIcon = function SvgCardLinkIcon(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 212,
    viewBox: "0 0 231 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.25 34.3532H204.381C208.106 34.3532 211.086 37.3332 211.086 41.0583V41.2239C211.086 45.1145 207.941 48.1773 204.133 48.1773H187.908C185.176 48.1773 182.941 50.4123 182.941 53.144C182.941 55.8757 185.176 58.1107 187.908 58.1107H216.798C223.751 58.1107 229.297 63.7397 229.297 70.6104C229.297 77.5638 223.668 83.11 216.798 83.11H195.772C193.289 83.11 191.302 85.0967 191.302 87.58C191.302 90.0634 193.289 92.0501 195.772 92.0501H216.881C220.109 92.0501 222.675 94.6162 222.675 97.8446C222.675 101.073 220.109 103.639 216.881 103.639H189.564C186.832 103.639 184.597 105.874 184.597 108.606C184.597 111.338 186.832 113.573 189.564 113.573H224C226.98 113.573 229.38 115.973 229.38 118.953C229.38 121.933 226.98 124.334 224 124.334H195.193C190.723 124.334 187.163 127.976 187.163 132.363C187.163 136.833 190.805 140.393 195.193 140.393H204.629C210.093 140.393 214.48 144.78 214.48 150.244C214.48 155.707 210.093 160.094 204.629 160.094H174.332",
    stroke: "#EAEAF0",
    strokeWidth: 2.48337,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1174 161.419H21.1086C18.7908 161.419 16.9697 159.598 16.9697 157.28C16.9697 154.962 18.7908 153.141 21.1086 153.141H39.7339C43.6245 153.141 46.7701 149.995 46.7701 146.105C46.7701 142.214 43.6245 139.069 39.7339 139.069H9.93348C6.53955 139.069 3.72507 136.254 3.72507 132.86C3.72507 129.466 6.53955 126.652 9.93348 126.652H32.2838C36.5883 126.652 40.1478 123.092 40.1478 118.788C40.1478 114.483 36.5883 110.924 32.2838 110.924H23.1781C16.9697 110.924 12.003 105.957 12.003 99.7486C12.003 93.5401 16.9697 88.5734 23.1781 88.5734H39.7339C42.2172 88.5734 44.2867 86.5039 44.2867 84.0206C44.2867 81.5372 42.2172 79.4677 39.7339 79.4677H5.38064C3.06283 79.4677 1.2417 77.6466 1.2417 75.3288C1.2417 73.011 3.06283 71.1898 5.38064 71.1898H43.4589C47.5979 71.1898 50.909 67.8787 50.909 63.7398C50.909 59.6008 47.5979 56.2897 43.4589 56.2897H34.3532C27.9793 56.2897 22.7642 51.0746 22.7642 44.7006C22.7642 38.3266 27.9793 33.1116 34.3532 33.1116H57.1174",
    stroke: "#EAEAF0",
    strokeWidth: 2.48337,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8032 176.319C43.8605 176.319 45.5282 174.651 45.5282 172.594C45.5282 170.537 43.8605 168.869 41.8032 168.869C39.7459 168.869 38.0781 170.537 38.0781 172.594C38.0781 174.651 39.7459 176.319 41.8032 176.319Z",
    stroke: "#EAEAF0",
    strokeWidth: 2.48337,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.222 173.008C203.908 173.008 204.464 172.452 204.464 171.766C204.464 171.08 203.908 170.524 203.222 170.524C202.536 170.524 201.98 171.08 201.98 171.766C201.98 172.452 202.536 173.008 203.222 173.008Z",
    stroke: "#EAEAF0",
    strokeWidth: 2.48337,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.494 24.8336C188.18 24.8336 188.736 24.2777 188.736 23.592C188.736 22.9062 188.18 22.3503 187.494 22.3503C186.808 22.3503 186.252 22.9062 186.252 23.592C186.252 24.2777 186.808 24.8336 187.494 24.8336Z",
    stroke: "#EAEAF0",
    strokeWidth: 2.48337,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3472 57.1174C11.0329 57.1174 11.5888 56.5615 11.5888 55.8757C11.5888 55.19 11.0329 54.634 10.3472 54.634C9.66139 54.634 9.10547 55.19 9.10547 55.8757C9.10547 56.5615 9.66139 57.1174 10.3472 57.1174Z",
    stroke: "#EAEAF0",
    strokeWidth: 2.48337,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.908 170.524V178.802",
    stroke: "#F9DA87",
    strokeWidth: 2.48337,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.046 174.663H183.769",
    stroke: "#F9DA87",
    strokeWidth: 2.48337,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0781 12.4168V20.6947",
    stroke: "#F9DA87",
    strokeWidth: 2.48337,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2169 16.5557H33.939",
    stroke: "#F9DA87",
    strokeWidth: 2.48337,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.8 111.338V15.0657C166.8 11.5063 163.902 8.69177 160.426 8.69177H137.827C137.496 11.9201 134.764 14.4863 131.453 14.4863H99.5004C96.1892 14.4863 93.4575 11.9201 93.1264 8.69177H70.5278C66.9683 8.69177 64.1538 11.589 64.1538 15.0657V111.338",
    stroke: "#FED46D",
    strokeWidth: 2.48337,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1538 111.338V196.02C64.1538 199.58 67.0511 202.394 70.5278 202.394H160.426C163.985 202.394 166.8 199.497 166.8 196.02V111.338",
    stroke: "#FED46D",
    strokeWidth: 2.48337,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.459 210.258H187.494",
    stroke: "#FED46D",
    strokeWidth: 2.48337,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.25 111.338V12.8307C174.25 6.45677 169.035 1.2417 162.661 1.2417H68.2927C61.9187 1.2417 56.7036 6.45677 56.7036 12.8307V111.338",
    stroke: "#FED46D",
    strokeWidth: 2.48337,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7041 111.338V198.255C56.7041 204.629 61.9192 209.844 68.2931 209.844H162.661C169.035 209.844 174.25 204.629 174.25 198.255V111.338",
    stroke: "#FED46D",
    strokeWidth: 2.48337,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.383 191.651H76.5709C75.0259 191.651 73.7598 190.385 73.7598 188.84V143.311C73.7598 141.766 75.0259 140.5 76.5709 140.5H154.383C155.928 140.5 157.194 141.766 157.194 143.311V188.84C157.194 190.385 155.928 191.651 154.383 191.651Z",
    fill: "white",
    stroke: "#EAEAF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.413 184.701C140.384 184.701 142.793 182.292 142.793 179.32C142.793 176.348 140.384 173.939 137.413 173.939C134.441 173.939 132.032 176.348 132.032 179.32C132.032 182.292 134.441 184.701 137.413 184.701Z",
    stroke: "#9498B5",
    strokeWidth: 2.48337,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.697 184.701C147.669 184.701 150.078 182.292 150.078 179.32C150.078 176.348 147.669 173.939 144.697 173.939C141.725 173.939 139.316 176.348 139.316 179.32C139.316 182.292 141.725 184.701 144.697 184.701Z",
    stroke: "#6F719B",
    strokeWidth: 2.48337,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0706 169.386H83.0277C81.9516 169.386 81.041 168.476 81.041 167.4V164.668C81.041 163.592 81.9516 162.681 83.0277 162.681H89.0706C90.1467 162.681 91.0573 163.592 91.0573 164.668V167.4C91.0573 168.476 90.1467 169.386 89.0706 169.386Z",
    fill: "#FED46D",
    stroke: "#FED46D",
    strokeWidth: 2.48337,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.824 149.52H149.83",
    stroke: "#EAEAF0",
    strokeWidth: 2.48337,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.91 96.492C145.91 85.8235 138.318 77.8984 128.295 77.8984C123.479 77.8984 119.26 79.9945 117.115 82.7027C117.079 82.7486 117.024 82.7754 116.966 82.7754C116.853 82.7754 116.765 82.6777 116.777 82.5657L118.176 69.6463C118.231 69.1387 118.66 68.754 119.171 68.754H141.873C142.425 68.754 142.873 68.3063 142.873 67.754V60C142.873 59.4477 142.425 59 141.873 59H109.466C108.95 59 108.518 59.3935 108.471 59.9079L105.906 87.6461C105.858 88.1658 106.218 88.6351 106.733 88.7236L115.847 90.2918C116.218 90.3556 116.588 90.2022 116.838 89.921C118.722 87.799 121.838 86.738 124.955 86.738C130.725 86.738 134.673 91.0053 134.673 96.7968C134.673 102.588 130.725 106.551 125.258 106.551C120.757 106.551 117.299 103.936 116.572 100.159C116.473 99.6435 116.044 99.2353 115.52 99.2353H105.942C105.377 99.2353 104.922 99.7036 104.973 100.266C105.823 109.479 114.128 116 125.258 116C137.406 116 145.91 107.77 145.91 96.492Z",
    fill: "#7CDA98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102 76.1265C102 71.3265 98.2597 68.9265 92.961 67.7265L92.7205 67.6494C92.3067 67.5166 92.026 67.1318 92.026 66.6972V61.6734C92.026 61.067 92.5698 60.5853 93.1395 60.7932C94.2639 61.2035 94.9118 61.9697 95.2544 63.0096C95.4066 63.4716 95.8098 63.8265 96.2963 63.8265H100.377C100.929 63.8265 101.383 63.3766 101.321 62.8279C100.867 58.8437 97.6853 56.0585 93.0047 55.2616C92.465 55.1698 92.0674 54.6882 92.1188 54.1432L92.2343 52.9206C92.2898 52.3338 91.8282 51.8265 91.2388 51.8265H89.9091C89.3568 51.8265 88.9091 52.2743 88.9091 52.8265V54.2227C88.9091 54.736 88.5188 55.1627 88.0115 55.2402C82.5814 56.0696 78.9351 59.2731 78.9351 63.8265C78.9351 68.0265 82.0519 70.4265 87.039 71.6265L87.5197 71.7422C87.969 71.8503 88.2857 72.2523 88.2857 72.7145V78.1144C88.2857 78.7747 87.6517 79.26 87.0505 78.9871C85.7703 78.4057 84.8279 77.4993 84.4121 76.0861C84.2703 75.604 83.8577 75.2265 83.3552 75.2265H79C78.4477 75.2265 77.9946 75.6757 78.0433 76.2258C78.4689 81.031 82.0026 83.9145 87.3341 84.4558C87.8649 84.5097 88.2857 84.946 88.2857 85.4796V86.8265C88.2857 87.3788 88.7334 87.8265 89.2857 87.8265H90.7143C91.2666 87.8265 91.7143 87.3788 91.7143 86.8265V85.4818C91.7143 84.9473 92.1368 84.5103 92.6689 84.4598C98.6221 83.8949 102 80.6881 102 76.1265ZM88.5974 65.1555C88.5974 65.8333 87.9307 66.3233 87.3257 66.0178C86.1836 65.441 85.4805 64.6529 85.4805 63.5265C85.4805 62.3531 86.2434 61.3633 87.4709 60.8443C88.0378 60.6046 88.5974 61.0843 88.5974 61.6997V65.1555ZM93.2584 78.9793C92.6606 79.2597 92.026 78.7747 92.026 78.1144V74.1387C92.026 73.4784 92.6602 72.9903 93.2683 73.2474C94.6744 73.8419 95.4545 74.7026 95.4545 76.1265C95.4545 77.3159 94.6707 78.3167 93.2584 78.9793Z",
    fill: "#7CDA98"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 230.539,
    height: 211.5,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgCardLinkIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/card_link_icon.a2e064757474176adc0f8f251aa4e9d5.svg";